import { render, staticRenderFns } from "./StateList.vue?vue&type=template&id=a975d4a4"
import script from "./StateList.vue?vue&type=script&lang=ts"
export * from "./StateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports